import { render, staticRenderFns } from "./AscPlatformTile.vue?vue&type=template&id=b8e4872e&"
import script from "./AscPlatformTile.vue?vue&type=script&lang=js&"
export * from "./AscPlatformTile.vue?vue&type=script&lang=js&"
import style0 from "./AscPlatformTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports